var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 181 59",
    enableBackground: "new 0 0 181 59",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M46.3,8.3h1.4l3.5,7.6l3.5-7.6h1.4v9.8h-1.4v-7l-3.2,7h-0.7l-3.2-7v7h-1.4V8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5,17.8c-0.6-0.3-1-0.7-1.3-1.2c-0.3-0.5-0.5-1.2-0.5-1.9c0-0.7,0.2-1.3,0.5-1.9c0.3-0.5,0.8-1,1.3-1.3 c0.6-0.3,1.2-0.4,2-0.4c0.8,0,1.4,0.1,2,0.4c0.6,0.3,1,0.7,1.4,1.3c0.3,0.5,0.5,1.2,0.5,1.9c0,0.7-0.2,1.4-0.5,1.9 c-0.3,0.5-0.8,0.9-1.4,1.2c-0.6,0.3-1.2,0.4-2,0.4C60.7,18.3,60,18.1,59.5,17.8z M63.2,16.5c0.4-0.4,0.6-1,0.6-1.8 c0-0.8-0.2-1.4-0.6-1.8c-0.4-0.4-1-0.7-1.7-0.7s-1.3,0.2-1.7,0.7c-0.4,0.4-0.6,1-0.6,1.8c0,0.7,0.2,1.3,0.6,1.8 c0.4,0.4,1,0.7,1.7,0.7S62.8,16.9,63.2,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6,17.7c-0.4-0.4-0.6-0.9-0.6-1.7v-3.6h-1v-1.1h1v-2h1.4v2h1.7v1.1h-1.7v3.5c0,0.4,0.1,0.8,0.3,1 c0.2,0.2,0.5,0.3,0.9,0.3c0.3,0,0.5-0.1,0.8-0.2v1.1c-0.4,0.1-0.8,0.2-1.3,0.2C68.5,18.3,68,18.1,67.6,17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3,17.8c-0.6-0.3-1-0.7-1.3-1.2c-0.3-0.5-0.5-1.2-0.5-1.9c0-0.7,0.2-1.3,0.5-1.9c0.3-0.5,0.8-1,1.3-1.3 c0.6-0.3,1.2-0.4,2-0.4c0.8,0,1.4,0.1,2,0.4c0.6,0.3,1,0.7,1.4,1.3c0.3,0.5,0.5,1.2,0.5,1.9c0,0.7-0.2,1.4-0.5,1.9 c-0.3,0.5-0.8,0.9-1.4,1.2c-0.6,0.3-1.2,0.4-2,0.4C74.6,18.3,73.9,18.1,73.3,17.8z M77.1,16.5c0.4-0.4,0.6-1,0.6-1.8 c0-0.8-0.2-1.4-0.6-1.8c-0.4-0.4-1-0.7-1.7-0.7s-1.3,0.2-1.7,0.7c-0.4,0.4-0.6,1-0.6,1.8c0,0.7,0.2,1.3,0.6,1.8 c0.4,0.4,1,0.7,1.7,0.7S76.6,16.9,77.1,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7,11.3h1.4v1.2c0.3-0.4,0.7-0.7,1.2-0.9c0.5-0.2,1.1-0.3,1.8-0.3v1.1c-0.7,0-1.3,0.1-1.8,0.3 c-0.5,0.2-0.9,0.6-1.1,1.1v4.2h-1.4V11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3,25.1h1.4v9.8h-1.4V25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5,28.1h1.4v1c0.3-0.4,0.7-0.7,1.2-0.9c0.5-0.2,0.9-0.3,1.4-0.3c0.9,0,1.6,0.2,2,0.7c0.4,0.5,0.7,1.1,0.7,1.9v4.3h-1.4 v-4.2c0-1.1-0.5-1.6-1.6-1.6c-0.4,0-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.5-1,1v4.5h-1.4V28.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9,34.9c-0.5-0.1-0.9-0.3-1.2-0.5v-1.2c0.4,0.2,0.8,0.4,1.3,0.5c0.5,0.1,0.9,0.2,1.4,0.2c0.5,0,0.9-0.1,1.1-0.2 s0.4-0.3,0.4-0.6c0-0.2-0.1-0.4-0.2-0.5s-0.3-0.2-0.5-0.3s-0.6-0.2-1.2-0.4c-0.6-0.2-1-0.3-1.3-0.5c-0.3-0.2-0.6-0.4-0.7-0.6 c-0.2-0.3-0.2-0.6-0.2-1c0-0.6,0.3-1.1,0.8-1.5c0.5-0.3,1.2-0.5,2.1-0.5c0.4,0,0.9,0,1.3,0.1s0.8,0.2,1,0.4v1.2 c-0.3-0.2-0.6-0.3-1-0.4c-0.4-0.1-0.8-0.1-1.2-0.1c-0.5,0-0.9,0.1-1.1,0.2c-0.3,0.1-0.4,0.3-0.4,0.6c0,0.2,0.1,0.4,0.2,0.5 c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.6,0.2,1.2,0.3c0.8,0.2,1.4,0.5,1.8,0.8c0.3,0.3,0.5,0.8,0.5,1.3c0,0.6-0.2,1-0.7,1.4 c-0.5,0.3-1.2,0.5-2.1,0.5C60,35.1,59.5,35,58.9,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4,34.3c-0.5-0.5-0.7-1.1-0.7-1.9v-4.3h1.4v4.2c0,1.1,0.5,1.6,1.6,1.6c0.9,0,1.7-0.4,2.2-1.3v-4.5h1.4v6.7H70v-1 c-0.3,0.4-0.7,0.7-1.1,0.9c-0.4,0.2-0.9,0.3-1.4,0.3C66.6,35.1,65.9,34.8,65.4,34.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2,28.1h1.4v1.2c0.3-0.4,0.7-0.7,1.2-0.9c0.5-0.2,1.1-0.3,1.8-0.3v1.1c-0.7,0-1.3,0.1-1.8,0.3 c-0.5,0.2-0.9,0.6-1.1,1.1v4.2h-1.4V28.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6,34.4c-0.5-0.4-0.7-1-0.7-1.7c0-0.7,0.2-1.3,0.7-1.7c0.5-0.4,1.1-0.6,2-0.6c0.9,0,1.7,0.2,2.4,0.6v-0.3 c0-0.5-0.2-0.9-0.5-1.2c-0.3-0.3-0.8-0.4-1.5-0.4c-0.4,0-0.8,0-1.2,0.1c-0.4,0.1-0.7,0.2-1,0.3v-1.1c0.3-0.1,0.6-0.2,1.1-0.3 c0.4-0.1,0.9-0.1,1.3-0.1c1.1,0,1.9,0.2,2.5,0.7c0.5,0.5,0.8,1.2,0.8,2v4.2H83v-0.8c-0.3,0.3-0.6,0.6-1,0.7 c-0.4,0.2-0.9,0.2-1.4,0.2C79.7,35.1,79.1,34.9,78.6,34.4z M82.1,33.7c0.4-0.2,0.6-0.4,0.8-0.7v-0.9c-0.6-0.4-1.3-0.6-2-0.6 c-0.5,0-0.9,0.1-1.2,0.3s-0.4,0.5-0.4,1c0,0.8,0.5,1.2,1.6,1.2C81.3,34,81.8,33.9,82.1,33.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1,28.1h1.4v1c0.3-0.4,0.7-0.7,1.2-0.9c0.5-0.2,0.9-0.3,1.4-0.3c0.9,0,1.6,0.2,2,0.7c0.4,0.5,0.7,1.1,0.7,1.9v4.3h-1.4 v-4.2c0-1.1-0.5-1.6-1.6-1.6c-0.4,0-0.9,0.1-1.3,0.3s-0.7,0.5-1,1v4.5h-1.4V28.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1,34.6c-0.6-0.3-1-0.7-1.4-1.2c-0.3-0.5-0.5-1.2-0.5-1.9s0.2-1.4,0.5-1.9c0.3-0.5,0.8-0.9,1.4-1.2 c0.6-0.3,1.3-0.4,2-0.4c1,0,1.8,0.2,2.5,0.6v1.2c-0.6-0.4-1.4-0.6-2.3-0.6c-0.8,0-1.4,0.2-1.9,0.6c-0.5,0.4-0.7,1-0.7,1.8 s0.2,1.4,0.7,1.8c0.5,0.4,1.1,0.6,1.8,0.6c0.9,0,1.8-0.2,2.4-0.7v1.1c-0.3,0.2-0.7,0.4-1.1,0.5c-0.4,0.1-0.9,0.2-1.5,0.2 C97.3,35.1,96.6,34.9,96.1,34.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.9,34.1c-0.7-0.6-1.1-1.5-1.1-2.6c0-1.1,0.3-2,0.9-2.6c0.6-0.6,1.5-1,2.7-1c0.8,0,1.4,0.1,2,0.4 c0.5,0.3,0.9,0.7,1.2,1.2c0.3,0.5,0.4,1.1,0.4,1.8v0.7h-5.9c0,0.6,0.3,1.1,0.8,1.4c0.5,0.3,1.2,0.5,2,0.5c0.4,0,0.9,0,1.3-0.1 c0.4-0.1,0.8-0.2,1.2-0.3v1.1c-0.3,0.1-0.7,0.2-1.2,0.3c-0.5,0.1-1,0.1-1.4,0.1C104.6,35.1,103.6,34.8,102.9,34.1z M107.8,31.1 c0-0.6-0.2-1.1-0.6-1.5c-0.4-0.4-1-0.5-1.7-0.5c-0.7,0-1.3,0.2-1.7,0.5c-0.4,0.4-0.6,0.8-0.6,1.5H107.8z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M32,33.9H5.4v-3.1 c0-2.7,2.2-4.8,4.8-4.8h16.9c2.7,0,4.8,2.2,4.8,4.8V33.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M12.4,33.9v1.8 c0,1.5-1.2,2.8-2.8,2.8l0,0c-1.5,0-2.8-1.2-2.8-2.8v-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M30.6,33.9v1.8 c0,1.5-1.2,2.8-2.8,2.8l0,0c-1.5,0-2.8-1.2-2.8-2.8v-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M9.5,31.9H7.1 c-0.4,0-0.8-0.3-0.8-0.8v-0.4c0-0.4,0.3-0.8,0.8-0.8h2.3c0.4,0,0.8,0.3,0.8,0.8v0.4C10.2,31.5,9.9,31.9,9.5,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M30.3,31.9h-2.3 c-0.4,0-0.8-0.3-0.8-0.8v-0.4c0-0.4,0.3-0.8,0.8-0.8h2.3c0.4,0,0.8,0.3,0.8,0.8v0.4C31,31.5,30.7,31.9,30.3,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M20.7,30.9h-4 c-0.6,0-1.1-0.5-1.1-1.1l0,0c0-0.6,0.5-1.1,1.1-1.1h4c0.6,0,1.1,0.5,1.1,1.1l0,0C21.8,30.4,21.3,30.9,20.7,30.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M36.6,6.7 c-2.1-0.3-4.2-1.8-5-2.6c-0.2-0.2-0.6-0.2-0.8,0c-0.9,0.7-2.9,2.3-5,2.6c-0.3,0-0.6,0.3-0.6,0.7c0.3,6.4,4.5,9.3,5.7,9.9 c0.2,0.1,0.4,0.1,0.6,0c1.2-0.7,5.4-3.5,5.7-9.9C37.2,7.1,37,6.8,36.6,6.7z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 28.8,
    y1: 10.7,
    x2: 33.6,
    y2: 10.7
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 31.2,
    y1: 8.3,
    x2: 31.2,
    y2: 13.1
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 29.1,
    y1: 21.8,
    x2: 29.1,
    y2: 26
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M8.3,26v-7 c0-3.3,3.1-5.9,6.9-5.9h7.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M10.4,26v-5.6 c0-2.6,2.5-4.8,5.5-4.8h5.6c3,0,5.5,2.2,5.5,4.8V26"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M5.3,26.5 L5.3,26.5c-0.6,0-1-0.5-1-1v-2.1c0-0.6,0.5-1,1-1l0,0c0.6,0,1,0.5,1,1v2.1C6.4,26,5.9,26.5,5.3,26.5z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 6.4,
    y1: 24.4,
    x2: 8.3,
    y2: 24.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M32.5,26.5 L32.5,26.5c0.6,0,1-0.5,1-1v-2.1c0-0.6-0.5-1-1-1l0,0c-0.6,0-1,0.5-1,1v2.1C31.5,26,32,26.5,32.5,26.5z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 31.5,
    y1: 24.4,
    x2: 29.6,
    y2: 24.4
  }))), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 13.8,
    y1: 24.7,
    x2: 21.1,
    y2: 17.3
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 23.2,
    y1: 20.2,
    x2: 20.4,
    y2: 23.3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon-6.8283b62abccd0224ff80a688fa9c9b6f.svg";
export { ForwardRef as ReactComponent };